import React from 'react';
import { LayoutProps } from '@/types';

export interface AuthLayoutProps extends LayoutProps {
  title?: string;
  subtitle?: string;
  showLogo?: boolean;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
}) => {
  return <>{children}</>;
};